export const normalizeBundleKey = name =>
  `${name ?? ''}`
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['’`]/g, '')
    .replace(/[^A-Za-z0-9\s_-]/g, ' ')
    .trim()
    .replace(/[\s-]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')
    .toUpperCase();

export const humanizeValue = value =>
  value
    ? `${value}`
        .split('_')
        .map(part => part.charAt(0) + part.slice(1).toLowerCase())
        .join(' ')
    : '-';

export const formatMoney = (amount, currency) => {
  if (amount === null || amount === undefined) {
    return '-';
  }

  const parsedAmount = Number(amount);
  if (Number.isNaN(parsedAmount)) {
    return `${currency || ''} ${amount}`.trim();
  }

  return `${currency || ''} ${parsedAmount.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  })}`.trim();
};

export const getBundlePriceSummary = prices => {
  if (!Array.isArray(prices) || !prices.length) {
    return '-';
  }

  const firstPrice = prices[0];
  const base = formatMoney(firstPrice?.amount, firstPrice?.currency);
  if (prices.length === 1) {
    return base;
  }

  return `${base} (+${prices.length - 1} more)`;
};
